import { useEffect, useState } from "react";
import { Box, CircularProgress, Typography } from "@material-ui/core";
import { Link, useHistory, useLocation } from "react-router-dom";
import { logout } from "../../services/auth";
import useStyles from "./style";
import { Settings } from "@material-ui/icons";
import MuiLink from "@material-ui/core/Link";
import { usePermission } from "../../hooks/usePermission";
import { toast } from "react-toastify";
import { useAuth } from "../../contexts/auth";
import { useTicketOfficeList } from "../../services/api-tansquery/ticket-office-list";

export default function InitPage(): JSX.Element {
    const history = useHistory();
    const location = useLocation();
    const classes = useStyles();
    const { isAboveAttendant } = usePermission();
    const { authUser, currentTicketOffice, changeCurrentTicketOffice } =
        useAuth();
    const { data: ticketOfficeList, isLoading } = useTicketOfficeList();
    const [ticketOfficeSelected, setTicketOfficeSelected] = useState<string>();

    // Rotas administrativas que não precisam de guichê
    const adminRoutes = ['/admin', '/usuarios', '/locais-de-atendimento', '/totens', '/prioridades', '/atendentes', '/cancelamentos', '/reagendamentos'];
    const isAdminRoute = adminRoutes.some(route => location.pathname.startsWith(route));

    const handleSelectTicketOffice = async () => {
        if (ticketOfficeSelected) {
            const ticketOffice = ticketOfficeList?.find(
                (ticketOff) => ticketOff.id === parseInt(ticketOfficeSelected)
            );

            if (ticketOffice) {
                changeCurrentTicketOffice(ticketOffice);
                history.push("/home");
            }
        }
    };

    useEffect(() => {
        if (authUser && isAboveAttendant !== undefined) {
            if (isAboveAttendant && isAdminRoute) {
                // Redirecionar usuários administrativos diretamente para a rota administrativa
                history.push(location.pathname);
                return;
            }
        }
        
        if (authUser) {
            if (ticketOfficeList?.length === 0 && !isLoading) {
                toast.error("Nenhum guichê encontrado.");

                if (isAboveAttendant) {
                    // Usuários administrativos podem acessar /admin diretamente
                    setTimeout(() => {
                        history.push("/admin");
                    }, 2000);
                } else {
                    // Usuários atendentes precisam de guichê
                    setTimeout(() => {
                        logout();
                    }, 5000);
                }
            }
        }
    }, [authUser, ticketOfficeList, isLoading, history, isAboveAttendant, isAdminRoute, location.pathname]);

    useEffect(() => {
        const ticketOffice = localStorage.getItem("gov_ticket_office");

        if (authUser && currentTicketOffice && ticketOffice) {
            const pathname = localStorage.getItem("pathname_redirect_gov");
            const spathname = pathname === "/" ? "/home" : pathname;
            history.push(spathname || "/home");
        }
    }, [authUser, currentTicketOffice, history]);

    // Se usuário administrativo está acessando rota administrativa, mostrar tela de carregamento
    if (authUser && isAboveAttendant && isAdminRoute) {
        return (
            <Box className={classes.root}>
                <Box className={classes.main}>
                    <img
                        src="/assets/images/SupportAgent.svg"
                        className={classes.icon}
                        alt="logo Atendimento"
                    />
                    <Typography className={classes.text}>
                        Acessando área administrativa...
                    </Typography>
                    <CircularProgress className={classes.loading} />
                </Box>
            </Box>
        );
    }

    return (
        <Box className={classes.root}>
            {ticketOfficeList?.length > 0 ? (
                <Box className={classes.main}>
                    <Typography variant="h5" className={classes.text}>
                        Selecione o guichê
                    </Typography>
                    <Box>
                        <select
                            onChange={(e) =>
                                setTicketOfficeSelected(e.target.value)
                            }
                            className={classes.selectTicket}
                        >
                            <option value={null}> Selecione </option>
                            {ticketOfficeList?.map((ticket) => (
                                <option
                                    key={`ticket-${ticket?.id}`}
                                    value={ticket?.id}
                                >
                                    { }
                                    {`GUICHÊ ${ticket?.ordem} : ${ticket?.setor?.nome || "Misto"
                                        } - ${ticket?.tipo === "Diario"
                                            ? "Orgânico"
                                            : ticket?.tipo === "Interno"
                                                ? "Complementar"
                                                : ticket?.tipo
                                        } - ${ticket?.unidade?.nome ||
                                        ticket?.setor?.unidade?.nome ||
                                        ""}`}
                                </option>
                            ))}
                        </select>
                    </Box>
                    {ticketOfficeSelected && (
                        <Box>
                            <button
                                className={classes.btnSelectTicket}
                                onClick={handleSelectTicketOffice}
                            >
                                Selecionar
                            </button>
                        </Box>
                    )}
                </Box>
            ) : (
                <Box className={classes.main}>
                    <img
                        src="/assets/images/SupportAgent.svg"
                        className={classes.icon}
                        alt="logo Atendimento"
                    />
                    <Typography className={classes.text}>
                        Atendimento
                    </Typography>
                    <CircularProgress className={classes.loading} />
                </Box>
            )}

            {isAboveAttendant && (
                <MuiLink
                    component={Link}
                    className={classes.customLink}
                    to="/admin"
                >
                    <Settings htmlColor="#FFF" fontSize="large" />
                </MuiLink>
            )}
        </Box>
    );
}
